import {
  AuthorizationStatusService,
  AuthorizationStorage,
} from 'frontcore/domain/authorization/model/AuthorizationService.d'

export default class AuthenticatedStatusService implements AuthorizationStatusService {

  storage: AuthorizationStorage

  constructor (
    storage: AuthorizationStorage
  ) {
    this.storage = storage
  }

  setToken (token: string) {
    this.storage.set(token)
  }

  isAuthenticated () {
    return !!this.storage.get()
  }

}
